/**
 * Created by robincoburn on 29/09/15.
 */
angular.module('qkr').directive('couponType', (inventoryService, gettextCatalog, $uibModal, $filter, _, $log) => ({

    restrict: 'E',
    scope: {
        selectedProducts: '=',
        productList: '=',
        config: '=',
        couponForm: '=',
        errors: '=',
        model: '='
    },
    template: require('../../coupons/templates/couponType.html'),

    link(scope) {

        scope.isEdit = scope.config.isEdit;
        scope.canEdit = scope.config.canEdit;
        scope.currency = scope.config.currency;
        scope.categoryList = [];

        scope.couponTypes = [
            {
                type: 'COUPON_AMOUNT_OFF_BASKET',
                description: gettextCatalog.getString('Amount off cart'),
                aquireMechanisms: ['QRCODE', 'FIRST_VISIT', 'PURCHASE_REWARD']
            },
            {
                type: 'COUPON_PERCENT_OFF_BASKET',
                description: gettextCatalog.getString('Percent off cart'),
                aquireMechanisms: ['QRCODE', 'FIRST_VISIT', 'PURCHASE_REWARD']
            }
        ];

        scope.addProducts = function() {
            scope.pickingProduct = true;
            if (scope.categoryList.length > 0) {
                scope.showProdListModal();
            } else {
                inventoryService.loadProductCategoriesForInventory().then((promise) => {
                    scope.categoryList = promise;
                    scope.categoryList = scope.categoryList.filter((cat) => {
                        return cat.numItems > 0; // only want categories with more than 0 'active' products.
                    });
                    scope.showProdListModal();
                }).catch($log.error);
            }
        };

        scope.hasAquireMechanism = function(type) {
            return type.aquireMechanisms.indexOf(scope.model.aquireMechanism) !== -1;
        };

        scope.clearValue = function() {
            scope.value = undefined;
                scope.model.variants = [];
                scope.selectedProducts = [];
        };

        scope.setApplyToCheapest = function(applyToCheapest) {
            scope.model.applyToCheapest = applyToCheapest;
        };

        scope.showProdListModal = function() {
            const modalInstance2 = $uibModal.open({
                template: require('../../coupons/templates/couponProducts.html'),
                controller: 'couponProdSelectController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    preSelectedCategories() {
                        return scope.determineSelectedCategories();
                    },
                    preSelectedVariantIds() {
                        return scope.determineSelectedVariantIds();
                    },
                    categoryList() {
                        return scope.categoryList;
                    },
                    productList() {
                        return scope.productList;
                    }
                }
            });

            modalInstance2.result.then((result) => {
                scope.pickingProduct = false;
                if (result === 'cancel') {
                    return;
                }
                scope.model.variants = [];
                scope.selectedProducts = [];

                angular.forEach(result.productList, (prod) => {
                    angular.forEach(prod.variants, (variant) => {
                        if (variant.selected) {
                            scope.model.variants.push({id: variant.id});
                            if (scope.selectedProducts.indexOf(prod) === -1) {
                                scope.selectedProducts.push(prod);
                            }
                        }
                    });
                });
            }).catch($log.error);
        };

        scope.determineSelectedCategories = function() {
            const selectedCategories = [];
            angular.forEach(scope.selectedProducts, (prod) => {
                selectedCategories.push(prod.category);
            });
            return _.uniq($filter('orderBy')(selectedCategories, 'name'), (p) => p.name);
        };

        scope.determineSelectedVariantIds = function() {
            const ret = [];
            angular.forEach(scope.model.variants, (selectVariant) => {
                const variant = findVariant(scope.productList, selectVariant.id);
                if (variant) {
                    ret.push(variant.id);
                }
            });
            return ret;
        };

        const findVariant = function(productList, variantId) {
            return productList
                .reduce((acc, product) => acc.concat(product.variants), [])
                .find(prodVariant => prodVariant.id === variantId);
        };
    }
}));



// WEBPACK FOOTER //
// ./src/coupons/directives/couponType.js